import { classNames } from '../../utils/classnames';
import { navigate } from 'gatsby';

export const Button = ({ disabled, className, label, redirectUrl }) => {
  const handleClick = () => {
    if (redirectUrl) {
      navigate(redirectUrl);
    }
  };
  return (
    <button disabled={disabled} onClick={handleClick} className={classNames(className, disabled && 'bg-gray-600')}>
      {label}
    </button>
  );
};
